/**
 * IntelliGems A/B Test: PDP UPC trust row (under ATC)
 *
 * Control (A): data-pdp-upc-trust="false"
 * Variant (B): data-pdp-upc-trust="true"
 *
 * Injects 3 clickable UPCs after the geo shipping pill on all PDPs
 * (native theme + GemPages). Opens matching info modals.
 *
 * Dev preview: ?pdp_upc_trust_test=b
 */
(function () {
  'use strict';

  if (window.__pdpUpcTrustABTestInit) return;
  window.__pdpUpcTrustABTestInit = true;

  var BODY_ATTR = 'data-pdp-upc-trust';
  var ROOT_ATTR = 'data-pdp-upc-trust-root';
  var MARK_ATTR = 'data-pdp-upc-trust-injected';
  var MODAL_ID = 'pdp-upc-trust-ab-modal';
  var applying = false;
  var debounceTimer = null;
  var variantActive = null;
  var hostedRoot = null;
  var modalEl = null;
  var lastFocused = null;

  var ICONS_UI = {
    /* Black line icons — ATC row (no circle); modal adds gray circle via CSS */
    quality:
      '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M5 10.9998C8.3 9.3998 11.7 9.3998 15 10.9998C18.3 12.5998 21.7 12.5998 25 10.9998V22.9998C21.7 24.5998 18.3 24.5998 15 22.9998C11.7 21.3998 8.3 21.3998 5 22.9998V10.9998Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M5 14.9998C8.3 13.3998 11.7 13.3998 15 14.9998C18.3 16.5998 21.7 16.5998 25 14.9998" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M5 18.9998C8.3 17.3998 11.7 17.3998 15 18.9998C18.3 20.5998 21.7 20.5998 25 18.9998" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M27 3.5V8.5M24.5 6H29.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>',
    shipping:
      '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M13 11.5L20 8L27 11.5V20.5L20 24L13 20.5V11.5Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M13 11.5L20 15M20 15L27 11.5M20 15V24" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path opacity="0.45" d="M16.5 9.75L23.5 13.25" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M4 13H9M5 21H9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M2.5 17H10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>',
    returns:
      '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M9.00009 8.89952C10.6505 7.28181 12.8103 6.28568 15.1122 6.08052C17.4141 5.87535 19.7161 6.4738 21.6266 7.77412C23.5371 9.07444 24.9382 10.9964 25.5918 13.2131C26.2454 15.4298 26.111 17.8044 25.2115 19.9332C24.312 22.062 22.7029 23.8135 20.6579 24.89C18.6128 25.9664 16.2581 26.3014 13.994 25.8378C11.73 25.3742 9.69637 24.1407 8.239 22.3471C6.78164 20.5535 5.99049 18.3105 6.00009 15.9995" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M3.5 18.5L6 16L8.5 18.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M13.2711 18.602C12.9197 18.602 12.6024 18.551 12.3191 18.449C12.0357 18.3413 11.7977 18.1912 11.6051 17.9985C11.4181 17.8002 11.2877 17.5678 11.2141 17.3015L12.2851 16.987C12.3247 17.055 12.3786 17.14 12.4466 17.242C12.5146 17.3383 12.6081 17.4205 12.7271 17.4885C12.8461 17.5565 13.0019 17.5905 13.1946 17.5905C13.4779 17.5905 13.7017 17.514 13.8661 17.361C14.0361 17.2023 14.1211 16.9983 14.1211 16.749C14.1211 16.579 14.0786 16.4288 13.9936 16.2985C13.9086 16.1682 13.7697 16.069 13.5771 16.001C13.3901 15.9273 13.1436 15.8905 12.8376 15.8905H12.4806V14.9385H12.8376C13.2342 14.9385 13.5289 14.8705 13.7216 14.7345C13.9142 14.5985 14.0106 14.4115 14.0106 14.1735C14.0106 14.0375 13.9766 13.9157 13.9086 13.808C13.8406 13.7003 13.7442 13.6153 13.6196 13.553C13.4949 13.4907 13.3504 13.4595 13.1861 13.4595C13.0784 13.4595 12.9679 13.4793 12.8546 13.519C12.7412 13.553 12.6364 13.6125 12.5401 13.6975C12.4494 13.7768 12.3757 13.893 12.3191 14.046L11.2651 13.7315C11.3444 13.4538 11.4804 13.2215 11.6731 13.0345C11.8714 12.8418 12.1066 12.6973 12.3786 12.601C12.6506 12.499 12.9311 12.448 13.2201 12.448C13.5884 12.448 13.9199 12.5188 14.2146 12.6605C14.5092 12.7965 14.7416 12.9863 14.9116 13.23C15.0816 13.4737 15.1666 13.7542 15.1666 14.0715C15.1666 14.3832 15.0787 14.6495 14.9031 14.8705C14.7331 15.0858 14.5036 15.2587 14.2146 15.389C14.5432 15.542 14.8039 15.746 14.9966 16.001C15.1892 16.2503 15.2856 16.545 15.2856 16.885C15.2856 17.242 15.1921 17.5508 15.0051 17.8115C14.8181 18.0665 14.5716 18.262 14.2656 18.398C13.9596 18.534 13.6281 18.602 13.2711 18.602ZM18.3597 18.602C17.878 18.602 17.453 18.4717 17.0847 18.211C16.7164 17.9447 16.4274 17.582 16.2177 17.123C16.008 16.6583 15.9032 16.1257 15.9032 15.525C15.9032 14.9243 16.008 14.3945 16.2177 13.9355C16.4274 13.4708 16.7135 13.1082 17.0762 12.8475C17.4445 12.5812 17.8695 12.448 18.3512 12.448C18.8329 12.448 19.2579 12.5812 19.6262 12.8475C20.0002 13.1082 20.292 13.4708 20.5017 13.9355C20.7114 14.3945 20.8162 14.9243 20.8162 15.525C20.8162 16.1257 20.7114 16.6583 20.5017 17.123C20.292 17.582 20.003 17.9447 19.6347 18.211C19.2664 18.4717 18.8414 18.602 18.3597 18.602ZM18.3597 17.548C18.6147 17.548 18.8414 17.463 19.0397 17.293C19.2437 17.1173 19.4024 16.8793 19.5157 16.579C19.629 16.273 19.6857 15.9217 19.6857 15.525C19.6857 15.1283 19.629 14.777 19.5157 14.471C19.4024 14.165 19.2437 13.927 19.0397 13.757C18.8414 13.5813 18.6119 13.4935 18.3512 13.4935C18.0962 13.4935 17.8695 13.5813 17.6712 13.757C17.4729 13.927 17.317 14.165 17.2037 14.471C17.096 14.777 17.0422 15.1283 17.0422 15.525C17.0422 15.9217 17.096 16.273 17.2037 16.579C17.317 16.8793 17.4729 17.1173 17.6712 17.293C17.8752 17.463 18.1047 17.548 18.3597 17.548Z" fill="currentColor"/>' +
      '</svg>',
    check:
      '<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M3.5 9.2l3.4 3.4 7.6-7.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>',
    close:
      '<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M4.5 4.5l9 9M13.5 4.5l-9 9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
      '</svg>'
  };

  /* Modal badge: black SVG; gray circle comes from CSS */
  function rowIconHtml(key) {
    return ICONS_UI[key] || '';
  }

  function modalIconHtml(key) {
    return ICONS_UI[key] || '';
  }

  function shippingRegion() {
    var code = '';
    try {
      if (window.Shopify && Shopify.country) code = String(Shopify.country);
    } catch (e) {}
    if (!code) {
      try {
        var flag = document.querySelector('#country-flag, .geo-ship__flag img, [data-shipped-today-flag]');
        if (flag && flag.alt) code = String(flag.alt).replace(/[^a-z]/gi, '');
        if (!code && flag && flag.src) {
          var m = String(flag.src).match(/\/([a-z]{2})(?:\.|\?|$)/i);
          if (m) code = m[1];
        }
      } catch (e2) {}
    }
    code = (code || 'US').toUpperCase().slice(0, 2);
    if (code === 'GB') return 'UK';
    return code;
  }

  function getPanels() {
    var region = shippingRegion();
    var regionLabel = region === 'UK' ? 'UK' : region;

    return {
      quality: {
        key: 'quality',
        label: 'Quality You Can Feel',
        title: 'Quality you can feel',
        desc: 'We choose every material for how it feels in your hands and how it holds up in a real home. Soft on day one, and still soft after the wash.',
        points: [
          { title: 'Comfort first.', text: 'Fabrics picked for softness and breathability.' },
          { title: 'Made for everyday use.', text: 'Built to handle daily life and regular washing.' },
          { title: 'Loved by our customers.', text: 'Rated 4.9 out of 5 in verified reviews.' }
        ],
        showReviews: true
      },
      shipping: {
        key: 'shipping',
        label: 'Free, Fast Shipping',
        title: 'Free, fast shipping',
        desc:
          'Every ' +
          regionLabel +
          ' order ships free, with no minimum spend. We pack and send your order quickly so it\'s home with you sooner.',
        points: [
          { title: 'Free on every ' + regionLabel + ' order.', text: 'No codes, no minimums.' },
          { title: 'Processed in 1–2 business days.', text: 'Most orders leave the same day.' },
          {
            title: 'Arrives in 3–12 business days,',
            text: 'depending on your location. Tracking included.'
          }
        ],
        showReviews: false
      },
      returns: {
        key: 'returns',
        label: '30-Day Free Returns',
        title: '30-day free returns',
        desc: 'Try it in your home. If it isn\'t right, tell us within 30 days of delivery and we\'ll make it right with a full refund.',
        points: [
          { title: '30 days to decide.', text: 'Counted from the day your order arrives.' },
          { title: 'Money-back guarantee.', text: 'A prompt, hassle-free refund.' },
          { title: 'Rarely needed.', text: 'Fewer than 1% of customers ask for a refund.' }
        ],
        showReviews: false
      }
    };
  }

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('pdp_upc_trust_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isTruthy(value) {
    var normalized = String(value || '').trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'on' || normalized === 'yes';
  }

  function isVariantB() {
    if (isDevVariantB()) return true;
    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return false;
    return isTruthy(body.getAttribute(BODY_ATTR)) || isTruthy(html.getAttribute(BODY_ATTR));
  }

  function isProductPage() {
    if (!document.body) return false;
    if (document.body.classList.contains('template-product')) return true;
    if (window.theme && window.theme.pageType === 'product') return true;
    return /\/products\//.test(window.location.pathname);
  }

  function buildRowHtml() {
    var panels = getPanels();
    var keys = ['quality', 'shipping', 'returns'];
    var html = '<div class="pdp-upc-trust-ab__row" role="list">';

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var panel = panels[key];
      html +=
        '<button type="button" class="pdp-upc-trust-ab__item" role="listitem" data-pdp-upc-trust-open="' +
        key +
        '" aria-haspopup="dialog">' +
        '<span class="pdp-upc-trust-ab__icon">' +
        rowIconHtml(key) +
        '</span>' +
        '<span class="pdp-upc-trust-ab__label">' +
        panel.label +
        '</span>' +
        '</button>';
    }

    html += '</div>';
    return html;
  }

  function createRoot() {
    var root = document.createElement('div');
    root.className = 'pdp-upc-trust-ab';
    root.setAttribute(ROOT_ATTR, '');
    root.setAttribute(MARK_ATTR, 'true');
    root.innerHTML = buildRowHtml();
    return root;
  }

  function findInsertAnchor() {
    var selectors = [
      '[data-geo-shipping-block]',
      '.custom-shipping-container',
      '#geo-ship-badge',
      '.geo-ship'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.parentNode) return el;
    }

    var buyButtons = document.querySelector('.ProductForm__BuyButtons');
    if (buyButtons) return buyButtons;

    var atc =
      document.querySelector('.ProductForm__AddToCart') ||
      document.querySelector('[data-action="add-to-cart"]') ||
      document.querySelector('button[name="add"]') ||
      document.querySelector('[aria-label="Add to cart"]') ||
      document.querySelector('[data-type="add-to-cart-form"] button[type="submit"]');

    if (atc) {
      var wrap = atc.closest('.ProductForm__BuyButtons, .product-form, form, [class*="buy"], [class*="Buy"]');
      return wrap || atc;
    }

    return null;
  }

  function insertAfter(anchor, node) {
    if (!anchor || !anchor.parentNode || !node) return;
    if (anchor.nextSibling) anchor.parentNode.insertBefore(node, anchor.nextSibling);
    else anchor.parentNode.appendChild(node);
  }

  function ensureModal() {
    if (modalEl && document.body.contains(modalEl)) return modalEl;

    modalEl = document.createElement('div');
    modalEl.id = MODAL_ID;
    modalEl.className = 'pdp-upc-trust-ab-modal';
    modalEl.setAttribute('data-open', 'false');
    modalEl.setAttribute('aria-hidden', 'true');
    modalEl.innerHTML =
      '<div class="pdp-upc-trust-ab-modal__backdrop" data-pdp-upc-trust-close></div>' +
      '<div class="pdp-upc-trust-ab-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="pdp-upc-trust-ab-title" tabindex="-1">' +
      '<div class="pdp-upc-trust-ab-modal__top">' +
      '<div class="pdp-upc-trust-ab-modal__badge" data-pdp-upc-trust-badge></div>' +
      '<button type="button" class="pdp-upc-trust-ab-modal__close" data-pdp-upc-trust-close aria-label="Close">' +
      ICONS_UI.close +
      '</button>' +
      '</div>' +
      '<h2 class="pdp-upc-trust-ab-modal__title" id="pdp-upc-trust-ab-title" data-pdp-upc-trust-title></h2>' +
      '<p class="pdp-upc-trust-ab-modal__desc" data-pdp-upc-trust-desc></p>' +
      '<ul class="pdp-upc-trust-ab-modal__list" data-pdp-upc-trust-list></ul>' +
      '<div class="pdp-upc-trust-ab-modal__footer" data-pdp-upc-trust-footer>' +
      '<button type="button" class="pdp-upc-trust-ab-modal__link" data-pdp-upc-trust-reviews>Read reviews</button>' +
      '<button type="button" class="pdp-upc-trust-ab-modal__got-it" data-pdp-upc-trust-close>GOT IT</button>' +
      '</div>' +
      '</div>';

    document.body.appendChild(modalEl);
    return modalEl;
  }

  function renderPanel(key) {
    var panels = getPanels();
    var panel = panels[key];
    if (!panel) return;

    var modal = ensureModal();
    var badge = modal.querySelector('[data-pdp-upc-trust-badge]');
    var title = modal.querySelector('[data-pdp-upc-trust-title]');
    var desc = modal.querySelector('[data-pdp-upc-trust-desc]');
    var list = modal.querySelector('[data-pdp-upc-trust-list]');
    var footer = modal.querySelector('[data-pdp-upc-trust-footer]');
    var reviewsBtn = modal.querySelector('[data-pdp-upc-trust-reviews]');

    if (badge) badge.innerHTML = modalIconHtml(key);
    if (title) title.textContent = panel.title;
    if (desc) desc.textContent = panel.desc;

    if (list) {
      var items = '';
      for (var i = 0; i < panel.points.length; i++) {
        var point = panel.points[i];
        items +=
          '<li>' +
          '<span class="pdp-upc-trust-ab-modal__check">' +
          ICONS_UI.check +
          '</span>' +
          '<span class="pdp-upc-trust-ab-modal__point"><strong>' +
          point.title +
          '</strong> ' +
          point.text +
          '</span>' +
          '</li>';
      }
      list.innerHTML = items;
    }

    if (footer) {
      footer.classList.toggle('pdp-upc-trust-ab-modal__footer--end', !panel.showReviews);
    }
    if (reviewsBtn) {
      reviewsBtn.style.display = panel.showReviews ? '' : 'none';
    }
  }

  function openModal(key) {
    renderPanel(key);
    var modal = ensureModal();
    lastFocused = document.activeElement;
    modal.setAttribute('data-open', 'true');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pdp-upc-trust-ab-modal-open');
    var dialog = modal.querySelector('.pdp-upc-trust-ab-modal__dialog');
    if (dialog) dialog.focus();
  }

  function closeModal() {
    if (!modalEl) return;
    modalEl.setAttribute('data-open', 'false');
    modalEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pdp-upc-trust-ab-modal-open');
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try {
        lastFocused.focus();
      } catch (e) {}
    }
  }

  function scrollToReviews() {
    closeModal();
    var selectors = [
      '#ryviu-widget-reviews',
      'ryviu-widget',
      '#r--ryviu-widget',
      '.ryviu-widget',
      '[id*="ryviu"]',
      '.yotpo-main-widget',
      '#shopify-product-reviews'
    ];

    var target = null;
    for (var i = 0; i < selectors.length; i++) {
      target = document.querySelector(selectors[i]);
      if (target) break;
    }

    if (!target) return;
    setTimeout(function () {
      try {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        target.scrollIntoView(true);
      }
    }, 80);
  }

  function removeHosted() {
    if (hostedRoot && hostedRoot.parentNode) {
      hostedRoot.parentNode.removeChild(hostedRoot);
    }
    hostedRoot = null;

    var leftovers = document.querySelectorAll('[' + ROOT_ATTR + ']');
    for (var i = 0; i < leftovers.length; i++) {
      if (leftovers[i].parentNode) leftovers[i].parentNode.removeChild(leftovers[i]);
    }
  }

  function syncInjection() {
    if (!isProductPage() || !isVariantB()) {
      removeHosted();
      return;
    }

    var existing = document.querySelector('[' + ROOT_ATTR + ']');
    if (existing && existing.isConnected) {
      hostedRoot = existing;
      return;
    }

    var anchor = findInsertAnchor();
    if (!anchor) return;

    hostedRoot = createRoot();
    insertAfter(anchor, hostedRoot);
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      var variantB = isVariantB() && isProductPage();
      document.documentElement.classList.toggle('pdp-upc-trust-b', variantB);

      if (!variantB) {
        removeHosted();
        closeModal();
        variantActive = false;
        return;
      }

      syncInjection();
      variantActive = true;
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyVariant, 40);
  }

  function onDocumentClick(event) {
    var openBtn = event.target.closest && event.target.closest('[data-pdp-upc-trust-open]');
    if (openBtn) {
      event.preventDefault();
      openModal(openBtn.getAttribute('data-pdp-upc-trust-open'));
      return;
    }

    var reviewsBtn = event.target.closest && event.target.closest('[data-pdp-upc-trust-reviews]');
    if (reviewsBtn) {
      event.preventDefault();
      scrollToReviews();
      return;
    }

    var closeBtn = event.target.closest && event.target.closest('[data-pdp-upc-trust-close]');
    if (closeBtn) {
      event.preventDefault();
      closeModal();
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape' && modalEl && modalEl.getAttribute('data-open') === 'true') {
      closeModal();
    }
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    applyVariant();

    // GemPages / late geo pill
    var tries = 0;
    var wait = setInterval(function () {
      tries += 1;
      if (isVariantB() && isProductPage()) syncInjection();
      if (tries > 40 || (hostedRoot && hostedRoot.isConnected)) clearInterval(wait);
    }, 250);

    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('keydown', onKeydown);

    if (!document.body) return;

    new MutationObserver(function (mutations) {
      if (applying) return;

      var shouldApply = false;
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'attributes') {
          shouldApply = true;
          break;
        }
        if (mutation.type === 'childList' && isVariantB() && isProductPage()) {
          if (!hostedRoot || !hostedRoot.isConnected) {
            shouldApply = true;
            break;
          }
        }
      }

      if (shouldApply) scheduleApply();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active', 'class'],
      childList: true,
      subtree: true
    });

    document.addEventListener('gem:variant:changed', scheduleApply);
  }

  window.PdpUpcTrustABTest = {
    enable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'true');
      variantActive = null;
      applyVariant();
    },
    disable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'false');
      variantActive = null;
      applyVariant();
    },
    isActive: isVariantB,
    open: openModal,
    close: closeModal
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
